import { __assign, __rest } from "tslib";
import React from 'react';
import { Box } from '@marvelapp/ui';
import SpecsPanelLabel from '../SpecsPanelLabel';
import SpecsValue from '../SpecsValue';
export default function SpecsPanelProperty(_a) {
    var children = _a.children, fontFamily = _a.fontFamily, isDisabled = _a.isDisabled, label = _a.label, transitionType = _a.transitionType, wordBreak = _a.wordBreak, color = _a.color, minWidth = _a.minWidth, props = __rest(_a, ["children", "fontFamily", "isDisabled", "label", "transitionType", "wordBreak", "color", "minWidth"]);
    return (React.createElement(Box, __assign({}, props),
        React.createElement(SpecsPanelLabel, null, label),
        React.createElement(SpecsValue, { color: color, fontFamily: fontFamily, isDisabled: isDisabled, minWidth: minWidth, transitionType: transitionType, truncated: true, wordBreak: wordBreak }, children)));
}
